<template>
  <section class="access-denied-page">

    <div class="card">

      <!-- Icon -->
      <div class="icon-wrap">
        <i class='bx bx-block'></i>
      </div>

      <!-- Content -->
      <h1>Access Restricted</h1>

      <p class="desc">
        You do not have permission to view this section.
        This action requires a higher access level.
      </p>

      <!-- Context -->
      <div class="meta">
        <div>
          <span>Requested Area</span>
          <strong>{{ requestedPath }}</strong>
        </div>
        <div>
          <span>Your Role</span>
          <strong>{{ role }}</strong>
        </div>
      </div>

      <!-- Actions -->
      <div class="actions">
        <button class="primary-btn" @click="goDashboard">
          Back to Dashboard
        </button>

        <button class="ghost-btn" @click="logout">
          Logout
        </button>
      </div>

    </div>

  </section>
</template>

<script>
export default {
  name: "AdminAccessDenied",

  data() {
    return {
      role: "Sub Admin", // or fetched from auth context
      requestedPath: window.location.pathname
    };
  },

  methods: {
    goDashboard() {
      this.$router.push("/admin");
    },
    logout() {
      // clear auth tokens here
      this.$router.push("/admin/login");
    }
  }
};
</script>

<style scoped>
.access-denied-page {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

.card {
  background: white;
  border-radius: 28px;
  padding: 48px;
  max-width: 520px;
  width: 100%;
  border: 1px solid #e5e7eb;
  text-align: center;
}

/* Icon */
.icon-wrap {
  width: 64px;
  height: 64px;
  margin: 0 auto 24px;
  border-radius: 50%;
  background: #fef2f2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrap i {
  font-size: 32px;
  color: #991b1b;
}

/* Text */
h1 {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 12px;
}

.desc {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 32px;
}

/* Meta */
.meta {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  background: #f8fafc;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 32px;
}

.meta span {
  font-size: 11px;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 700;
}

.meta strong {
  font-size: 13px;
  display: block;
  margin-top: 4px;
}

/* Actions */
.actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.primary-btn {
  background: #0f172a;
  color: white;
  padding: 14px 22px;
  border-radius: 14px;
  font-weight: 700;
}

.ghost-btn {
  padding: 14px 22px;
  border-radius: 14px;
  font-weight: 700;
  color: #0f172a;
  background: #f1f5f9;
}

/* Mobile */
@media (max-width: 640px) {
  .card {
    padding: 32px;
  }

  .meta {
    grid-template-columns: 1fr;
  }

  .actions {
    flex-direction: column;
  }

  .actions button {
    width: 100%;
  }
}

/* ===============================
   ACCESS DENIED – MOBILE PATCH
   =============================== */
@media (max-width: 640px) {

  /* Page padding */
  .access-denied-page {
    padding: 24px 16px;
    min-height: 100vh;
  }

  /* Card */
  .card {
    padding: 28px 20px;
    border-radius: 20px;
  }

  /* Icon */
  .icon-wrap {
    width: 56px;
    height: 56px;
    margin-bottom: 20px;
  }

  .icon-wrap span {
    font-size: 28px;
  }

  /* Title */
  h1 {
    font-size: 22px;
    line-height: 1.25;
  }

  /* Description */
  .desc {
    font-size: 13px;
    margin-bottom: 24px;
  }

  /* Meta block */
  .meta {
    padding: 14px;
    gap: 12px;
    margin-bottom: 24px;
  }

  .meta strong {
    font-size: 12px;
    word-break: break-all;
  }

  /* Actions */
  .actions {
    gap: 10px;
  }

  .primary-btn,
  .ghost-btn {
    padding: 14px 16px;
    font-size: 14px;
    border-radius: 12px;
  }
}

</style>
